import React, { useState } from "react";
import { Drawer, Form, Input, InputNumber, Icon } from "antd";

import { useAxios } from "../../../../shared/hooks/useAxios";
import { useNotification } from "../../../../shared/hooks/useNotification";

const DrawerGrupo = ({ grupoId, ativo, visible, onClose, atualizarListagem, form }) => {
    const { loading, notAuthorized, fetchData } = useAxios();
    const notify = useNotification();

    const { getFieldDecorator } = form;

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                if (grupoId > 0) alterarGrupo();
                else adicionarGrupo();
            }
        });
    };

    const obterGrupo = async () => {
        const { data, error } = await fetchData({
            method: "get",
            url: `/api/habilidades/obter-grupo/${grupoId}`
        });

        if (!error) {
            form.setFieldsValue({ nome: data.nome, ordem: data.ordem });
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const adicionarGrupo = async () => {
        const formData = new FormData();

        formData.append("nome", form.getFieldValue("nome"));
        formData.append("ordem", form.getFieldValue("ordem"));

        const { data, error } = await fetchData({
            method: "post",
            url: "/api/habilidades/adicionar-grupo",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        if (!error) {
            notify.success("Sucesso", "Grupo adicionado com sucesso!");
            atualizarListagem();
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const alterarGrupo = async () => {
        const formData = new FormData();

        formData.append("Id", grupoId);
        formData.append("nome", form.getFieldValue("nome"));
        formData.append("ordem", form.getFieldValue("ordem"));

        const { data, error } = await fetchData({
            method: "put",
            url: "/api/habilidades/alterar-grupo",
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        if (!error) {
            notify.success("Sucesso", "Grupo alterado com sucesso!");
            atualizarListagem();
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const afterVisibleChange = visible => {
        form.resetFields();
        if (visible && grupoId > 0) obterGrupo();
    };

    return (
        <Drawer
            title={grupoId > 0 ? "Editar Grupo de Habilidades" : "Novo Grupo de Habilidades"}
            className="drawer-add-cursos"
            width={720}
            onClose={onClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-add-curso" layout="horizontal" onSubmit={handleSubmit}>
                    <div className="bloco">
                        <Form.Item label="Nome">
                            {getFieldDecorator("nome", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input disabled={!ativo} />)}
                        </Form.Item>
                        <Form.Item label="Ordem">
                            {getFieldDecorator("ordem", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<InputNumber className="input-25" disabled={!ativo} min={1} />)}
                        </Form.Item>
                    </div>
                    <div className="ant-drawer-footer">
                        <button
                            type="button"
                            className="botao-secundario"
                            onClick={onClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Voltar
                        </button>
                        {ativo && (
                            <button type="submit" className="botao-principal" disabled={loading}>
                                {loading ? <Icon type="loading" /> : null}
                                Salvar
                            </button>
                        )}
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

const FormDrawerGrupo = Form.create({ name: "form-drawer-grupo" })(DrawerGrupo);

export default FormDrawerGrupo;
